import { create } from 'zustand'
import LoginSuccessResponse from './LoginSuccessResponse'
import toast from 'react-hot-toast'

interface LoginState {
	accessToken: string | null
	refreshToken: string | null
	name: string | null
	profileImage: string | null
	ttl: string | null
	login: (tokens: { accessToken: string | null; refreshToken: string | null }) => void

	logout(isShowMessage: boolean, navigate?: (path: string) => void): void

	isLoggedIn: () => boolean
	setAccessToken: (accessToken: string) => void
}

const useLoginStore = create<LoginState>(set => ({
	accessToken: localStorage.getItem('access-token'),
	refreshToken: localStorage.getItem('refresh-token'),
	name: localStorage.getItem('name'),
	profileImage: localStorage.getItem('appUsers-image'),
	ttl: localStorage.getItem('ttl'),

	login: (response: LoginSuccessResponse) => {
		localStorage.setItem('access-token', response.accessToken)
		localStorage.setItem('refresh-token', response.refreshToken)
		localStorage.setItem('name', response.name)
		localStorage.setItem('appUsers-image', response.profileImage)
		localStorage.setItem('ttl', response.ttl.toString())

		if (response.isInternal === true) {
			localStorage.setItem('is-internal', 'true')
		}

		set({
			accessToken: response.accessToken,
			refreshToken: response.refreshToken,
			name: response.name,
			profileImage: response.profileImage,
			ttl: response.ttl.toString(),
		})
	},

	isLoggedIn: () => {
		const state = useLoginStore.getState()
		return state.accessToken !== null && state.accessToken !== ''
	},

	logout: (isShowMessage: boolean, navigate?: (path: string) => void) => {
		if (isShowMessage) {
			toast.success('로그아웃 했어요')
		}

		localStorage.removeItem('access-token')
		localStorage.removeItem('refresh-token')
		localStorage.removeItem('name')
		localStorage.removeItem('appUsers-image')
		localStorage.removeItem('ttl')
		localStorage.removeItem('isAdmin')
		set({ accessToken: null, refreshToken: null })

		if (navigate) {
			navigate('/')
		} else {
			window.location.href = '/'
		}
	},

	setAccessToken: (accessToken: string) => {
		localStorage.setItem('access-token', accessToken)
	},
}))

export default useLoginStore
